import styled from 'styled-components';
import IcoW01 from 'dc/IcoW01';
import Mod001 from 'dc/Mod001';
import { Typ35 } from 'dc/Typ';

export const Modal = styled(Mod001)`
  width: 100% !important;
  position: absolute;
  bottom: 0;
  > div {
    width: 100%;
    max-width: 100%;
    margin: 0;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
`;

export const CloseIcon = styled(IcoW01)`
  cursor: pointer;
  color: #607d8b;
  &:hover {
    color: #263238;
  }
  position: absolute;
  top: 0;
  right: 0;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: transparent;
  text-align: center;
  width: 100%;
  max-width: 1020px;
  padding: 32px 0 6px 0;
`;

export const Text = styled(Typ35)`
  margin-bottom: 8px;
  text-align: left;
`;

export const HorizontalRuler = styled.hr`
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  width: 100%;
  margin-bottom: 24px;
`;
